










import { Component, Vue, Prop } from 'vue-property-decorator';
import { getFileUrl } from '@/utils';
import ImageToolbar from '../Toolbars/ImageToolbar.vue';

@Component({
  components: {
    ImageToolbar,
  },
})
export default class ImageElement extends Vue {
  @Prop(String) filename!: string;
  @Prop(Boolean) selected!: boolean;

  url = '';
  setUrl = false;
  async mounted() {
    this.$parent.$parent.$emit('updateMoveableComponent', {
      keepRatio: true,
    });
    await this.setNewUrl();
    this.setUrl = true;
  }

  async setNewUrl() {
    this.url = await getFileUrl(this.filename);
  }

  onError() {
    if (this.setUrl) {
      this.setNewUrl();
    }
  }
}
